import React, { useContext, useState } from "react";
import { TableTitle } from "../../Material/single/MaterialList/Styled";
import { StyledTableCell } from "../../../shared/components/CustomTable/Styled";
import { IconButton, ListItem, ListItemText, TableRow } from "@mui/material";
import { MaterialExport } from "../../../data/entities";
import { ItemList as MaterialExportList, ItemListItem as MaterialExportListItem, ItemListItemQuantity as MaterialExportListItemQuantity } from "../../../shared/styled/ListItemStyles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Template from "../../../templates/export_material_template.docx";
import { generateDocument, generateDocumentBlob } from "../../../utils/exportUtils";
import { buildDocxData } from "../../../utils/docxBuilder";
import { materialExportHistoryDownloadDescriptor } from "../../../utils/docxMappings";
import ListView from "../../../shared/components/ListView";
import { MaterialsExportFilterType } from "../../../configs/filterTypes";
import { MaterialsExportSortTypes } from "../../../configs/sortTypes";
import { ROLE } from "../../../data/enums";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import DocxPreviewModal from "../../../shared/components/DocxPreviewModal";
import DownloadIcon from "@mui/icons-material/Download";
import { StyledButton } from "../../../shared/styled/TitleBar";
import MaterialHistoryDeepLinkPreview from "../MaterialHistoryDeepLinkPreview";

const MaterialExportHistoryTableColumns = [
    {
        text: 'Mã phiếu',
        icon: <></>
    },
    {
        text: 'Kho',
        icon: <></>
    },
    {
        text: 'Đối tượng',
        icon: <></>
    },
    {
        text: 'Người xuất kho',
        icon: <></>
    },
    {
        text: 'Phương thức xuất',
        icon: <></>
    },
    {
        text: 'Ghi chú',
        icon: <></>
    },
    {
        text: 'Vật tư xuất',
        icon: <></>
    },
    {
        text: 'Ngày tạo',
        icon: <></>
    },
    {
        text: 'Ngày xuất kho',
        icon: <></>
    },
    {
        text: 'Xem trước phiếu',
        icon: <></>
    },
];


interface MaterialImportExportHistoryRowProps {
    item: MaterialExport;
    extraRowProps: any;
}

const MaterialImportExportHistoryRow = ({ item, extraRowProps }: MaterialImportExportHistoryRowProps) => {
    const {
        user: { role }
    } = useContext(AuthenticationContext);

    const itemDate = new Date(item.export_date);
    const exportData = buildDocxData(item, materialExportHistoryDownloadDescriptor);

    const [previewBlob, setPreviewBlob] = useState<Blob | null>(null);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    const onClickPreview = () => {
        generateDocumentBlob(exportData, Template).then((blob) => {
            console.debug("Generated DOCX blob for preview", { size: blob.size, type: blob.type });
            setPreviewBlob(blob);
            setIsPreviewOpen(true);
        });
    }

    const onClickDownload = () => {
        generateDocument(exportData, Template, `phieu_xuat_kho_${item.storage}_${itemDate.toLocaleDateString('en-GB')}`);
    }


    return (
        <>
            <TableRow>
                <StyledTableCell>{item.export_code}</StyledTableCell>
                {(![ROLE.FIRST_STORAGE_KEEPER, ROLE.SECOND_STORAGE_KEEPER].includes(role)) && (
                    <StyledTableCell style={{ whiteSpace: 'nowrap', wordBreak: 'keep-all' }}>{item.storage}</StyledTableCell>
                )}
                <StyledTableCell>{item.department}</StyledTableCell>
                <StyledTableCell>{item.receiverer_name}</StyledTableCell>
                <StyledTableCell>{item.export_method}</StyledTableCell>
                <StyledTableCell>{item.note}</StyledTableCell>
                <StyledTableCell>
                    <MaterialExportList>
                        {item.materials.map((material, index) => (
                            <ListItem 
                                key={material.material.id || index}
                                dense
                                disableGutters
                                style={{ padding: '2px 0' }}
                            >
                                <ListItemText
                                    primary={
                                        <MaterialExportListItem>        
                                            <span>{material.material.name}</span>
                                            <MaterialExportListItemQuantity>
                                                x{material.quantity}
                                            </MaterialExportListItemQuantity>
                                        </MaterialExportListItem>
                                    }
                                />
                            </ListItem>
                        ))}
                    </MaterialExportList>
                </StyledTableCell>
                <StyledTableCell>{new Date(item.created_at).toLocaleDateString('en-GB')}</StyledTableCell>
                <StyledTableCell>{new Date(item.export_date).toLocaleDateString('en-GB')}</StyledTableCell>
                <StyledTableCell>
                    <IconButton onClick={onClickPreview}>
                        <VisibilityIcon />
                    </IconButton>
                </StyledTableCell>
            </TableRow>
            
            <DocxPreviewModal
                open={isPreviewOpen}
                onClose={() => setIsPreviewOpen(false)}
                blob={previewBlob}
                title="Xem trước phiếu xuất kho"
                debug={false}
                actions={
                    <StyledButton
                        variant="outlined"
                        onClick={onClickDownload}
                    >
                        <DownloadIcon style={{ marginRight: '8px' }} />
                        Tải phiếu
                    </StyledButton>
                }
            />
        </>
    );
};

const MaterialExportHistory = () => {
    const {
        user: { role }
    } = useContext(AuthenticationContext);

    const getMaterialExportColumns = () => {
        const materialExportColumns = MaterialExportHistoryTableColumns;
        if ([ROLE.FIRST_STORAGE_KEEPER, ROLE.SECOND_STORAGE_KEEPER].includes(role)) {
            return materialExportColumns.filter(({text}) => text !== 'Kho');
        }
        return materialExportColumns;
    }

    return (
        <>
        <ListView
            // itemList={materialExports}
            url="/materials/exports/"
            filterTypes={MaterialsExportFilterType}
            sortTypes={MaterialsExportSortTypes}
            rowElement={MaterialImportExportHistoryRow}
            tableColumns={getMaterialExportColumns()}
            textString={"Tìm kiếm theo tên khách hàng, mã phiếu xuất kho, tên vật tư"}
        />
        <MaterialHistoryDeepLinkPreview kind="export" />
        </>
    );
};

export default MaterialExportHistory;
